import React from 'react'

const ProfileSectionYoutube = ({ section }) => {
  if (section.videoId) {
    return (
      <div className="vidwrap">
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            className="embed-responsive-item"
            src={`https://www.youtube.com/embed/${section.videoId}`}>
          </iframe>
        </div>
      </div>
    )
  }

  return null
}

export default ProfileSectionYoutube
